<script lang="ts">
  import { cx } from '@emotion/css';
  import { ResponsiveVars } from '@twist/core';
  import { toFluidVarInput } from '$lib/utils/fluidity';
  import { jobsStore } from '$lib/stores/Careers/jobsStore';

  const responsiveVars = new ResponsiveVars()
    .addFluid('font-size', toFluidVarInput(15, 15))
    .toCSS();
</script>

<p class={cx(responsiveVars, 'job-count')}>
  {`${$jobsStore.aggregates.total} job${$jobsStore.aggregates.total === 1 ? '' : 's'}`}
</p>

<style>
  .job-count {
    font-family: var(--font-family-primary);
    font-size: var(--font-size);
    font-weight: 600;
    line-height: 120%;
    letter-spacing: 6%;
    text-transform: uppercase;
  }
</style>
